import isAnalyticsEnabled from './is-analytics-enabled';

export default {
  isAnalyticsEnabled,
};
